export const SOCKET = {
  Events: {},
  Type: {
    Removal: 'removal',
  },
  Listeners: {
    Bulk_Status_Update: 'bulk-user-status-update',
    Bulk_Status_Update_Error: 'bulk-user-status-update-error',
    Join_Room_Error: 'join-room-error',
    User_Status_Update: 'user-status-update',
    Receive_Message: 'receive-message',
    Members_Added: 'members-added',
    Message_Status_Updated: 'message-status-updated',
    Messages_Read: 'messages-read',
    Message_Deleted: 'message-deleted',
    Message_Pin: 'message-pin',
    Message_Unpin: 'message-unpin',
    Message_Updated: 'message-updated',
    Message_Reaction_Updated: 'message-reaction-updated',
    Account_Deactivated: 'account-deactivated',
    Admin_Deactivation: 'admin-deactivation',
    Admin_Deletion: 'admin-deletion',
    Team_Deletion: 'team-deleted',
    Admin_Settings_Updated: 'admin-settings-updated',
    Password_Updated: 'password-updated',
    Message_Favorite: 'message-favorite',
    Do_Not_Disturb_Updated: 'dnd_status_updated',
    Member_Status_Updated: 'member_status_updated',
    Call_Ended: 'call-ended',
    Typing: 'typing',
    Group_Member_Added: 'group-member-added',
    Group_Member_Removed: 'group-member-removed',
    Member_Left_Group: 'member-left-group',
    Group_Left: 'group-left',
    Block_Status_Updated: 'block-status-updated',
    Member_Role_Updated: 'member-role-updated',
    Group_Settings_Updated: 'group-settings-updated',
    Group_Deleted: 'group-deleted',
    New_Group: 'new-group',

    Chat_Pin_Updated: 'chat-pin-updated',
    Chat_Archive_Updated: 'chat-archive-updated',
    Chat_Muted: 'chat_muted',
    Chat_Unmuted: 'chat_unmuted',
    Chat_Cleared: 'chat-cleared',
    Chats_Deleted_All: 'chats-deleted-all',
    Chats_Cleared_All: 'chats-cleared-all',
    Chat_Settings_Updated: 'chat-setting-updated',

    Status_Deleted: 'status-deleted',
    Status_Uploaded: 'status-uploaded',
    Status_Viewed: 'status-viewed',
    New_Notification: 'newNotification',
    User_Settings_Updated: 'user-settings-updated',
    Friend_User_Settings_Updated: 'friend-user-settings-updated',
    Admin_Banned_User: 'admin-banned-user',
    Broadcast_Recipients_Added: 'broadcast-recipients-added',
    Broadcast_Recipients_Removed: 'broadcast-recipients-removed',
    Announcement_Delete: 'announcement-delete',
  },
  Emitters: {
    Message_Delivered: 'message-delivered',
    Message_Seen: 'message-seen',
    Typing: 'typing',
    Join_Room: 'join-room',
    Send_Message: 'send-message',
    Set_Online: 'set-online',
    Set_Away: 'set-away',
    // Reports what the user is looking at (app state / open conversation) so the
    // server can skip FCM pushes for a chat they're already viewing.
    Presence_Update: 'presence-update',
    Add_Reaction: 'add-reaction',
    Remove_Reaction: 'remove-reaction',
    Member_Role_Updated: 'member-role-updated',
    Request_Status_Update: 'request-status-update',
    Mark_Last_Message_Seen: 'mark-last-message-seen',
    Mark_Messages_Read: 'mark-messages-read',

    Rejoin_Call: 'rejoin-call',
    Initiate_Call: 'initiate-call',
    Accept_Call: 'accept-call',
    Decline_Call: 'decline-call',
    End_Call: 'end-call',
    Toggle_Video: 'toggle-video',
    Toggle_Audio: 'toggle-audio',
    Ice_Candidate: 'ice-candidate',
    Webrtc_Offer: 'webrtc-offer',
    Webrtc_Answer: 'webrtc-answer',
    Sync_Participant_State: 'sync-participant-state',
    Toggle_Screen_Share: 'toggle-screen-sharing',
  },
}
